export default "__VITE_ASSET__kwUb9Lg$__"